import React from "react"

const IconFacebook = props => (
  <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10 3.42962H7.84766C6.92051 3.42962 6.39062 3.95398 6.39062 5.03577V7.1336H9.76816L9.28809 10.4281H6.39062V19H5.23184H4.20527H2.91387V10.4281H0V7.1336H2.91387V4.60963C2.91387 1.36446 5.19863 0.25 6.95371 0.25H10V3.42962Z" fill="currentColor" />
  </svg>
)

export default IconFacebook
